import { t } from "../../i18n"

export default function CwRowActions({
  onEdit,
  onDelete,
}: {
  onEdit: () => void
  onDelete: () => void
}) {
  return (
    <div className="flex flex-wrap items-center gap-3" onClick={(event) => event.stopPropagation()}>
      <button
        type="button"
        onClick={onEdit}
        className="font-semibold text-primary hover:underline"
      >
        {t("common.edit")}
      </button>
      <button
        type="button"
        onClick={onDelete}
        className="font-semibold text-primary-dark hover:underline"
      >
        {t("common.delete")}
      </button>
    </div>
  )
}
